import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH, APP_NAME } from 'configs/AppConfig';
import { decodeAuth } from 'utils/Helper';
import Cookies from 'js-cookie';
import { isStartWithUsercode } from 'config';
import loadable from "@loadable/component";

const getLocalAuth = Cookies.get("vb\C#^*gW589");
const dcode = getLocalAuth ? decodeAuth(getLocalAuth): null;

export const publicRoutes = [
    {
        key: 'admin-login',
        path: `${AUTH_PREFIX_PATH}/admin/login`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/auth-views/authentication/admin-login"), {
            fallback: '',
        }),
    },
    {
        key: 'agent-login',
        path: `${AUTH_PREFIX_PATH}/agent/login`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/auth-views/authentication/agent-login"), {
            fallback: '',
        }),
    },
    {
        key: 'change-password',
        path: `${AUTH_PREFIX_PATH}/change-password`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/auth-views/authentication/change-password"), {
            fallback: '',
        }),
    },
];

let role = dcode?.user?.role_name;
let usersRoute = [];

const isAdmin = (route) => {
    if(dcode?.user?.role_name === "admin" && dcode?.user?.type === "main"){
        return route;
    }else{
        return {};
    };
};

const isNotAdmin = (navRoute) => {
    if(dcode?.user?.role_name !== "admin"){
        return navRoute;
    }else{
        return {};
    };
};

 const isAgent = (navRoute) => {
    if(dcode?.user?.role_name === "agent"){
        return navRoute;
    }else{
        return {};
    };
  };
  
const isSubAdmin = (route,permit) => {
    if(dcode?.user?.role_name === "admin" && dcode?.user?.type === "sub"){
        if(dcode?.user?.permission === permit){
            return route;
        };
        return {};
    }else{
        return {};
    };
};
  
const isSubAccount = (navRoute,showAgent) => {
    if(dcode?.user?.role_name === "admin"){
        if(dcode?.user?.type === "sub"){
          return {};
        }else{
          return navRoute;
        }
    }else{
      if(dcode?.user?.type === "main"){
        return navRoute;
      }else{
        if(showAgent){
          return navRoute;
        }else{
          return {};
        };
      }
    };
  };

switch(role){
    case "admin":
      usersRoute = APP_NAME !== "sportsxzone" ? 
      [
        {
            key: 'member-agent',
            path: `${APP_PREFIX_PATH}/member/agents`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/Agent"), {
                fallback: '',
            }),
        },
      ]:
      [
        {
            key: 'member-super',
            path: `${APP_PREFIX_PATH}/member/supers`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/Super"), {
                fallback: '',
            }),
        }
      ];
   break;
   case "super":
     usersRoute = [
        {
            key: 'member-senior',
            path: `${APP_PREFIX_PATH}/member/seniors`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/Senior"), {
                fallback: '',
            }),
        }
     ]
   break;
   case "senior":
     usersRoute = [
        {
            key: 'member-master',
            path: `${APP_PREFIX_PATH}/member/masters`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/Master"), {
                fallback: '',
            }),
        },
        {
            key: 'member-agent',
            path: `${APP_PREFIX_PATH}/member/agents`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/Agent"), {
                fallback: '',
            }),
        },
        {
            key: 'member-user',
            path: `${APP_PREFIX_PATH}/member/users`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/User"), {
                fallback: '',
            }),
        },
     ]
   break;
   case "master":
    usersRoute = [
        {
            key: 'member-agent',
            path: `${APP_PREFIX_PATH}/member/agents`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/Agent"), {
                fallback: '',
            }),
        },
        {
            key: 'member-user',
            path: `${APP_PREFIX_PATH}/member/users`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/User"), {
                fallback: '',
            }),
        },
     ]
   break;
   case "agent":
    usersRoute = [
        {
            key: 'member-user',
            path: `${APP_PREFIX_PATH}/member/users`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/User"), {
                fallback: '',
            }),
        },
     ]
   break;
   default: 
 };

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/dashboards/default"), {
            fallback: '',
        }),
    },
    {
        key: 'dashboard.totalUser',
        path: `${APP_PREFIX_PATH}/dashboards/totalUser`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/dashboards/default/totalUser"), {
            fallback: '',
        }),
    },
    {
        key: 'change-password',
        path: `${APP_PREFIX_PATH}/account-setting/change-password`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/change-password"), {
            fallback: '',
        }),
    },
    isNotAdmin({
        key: 'profile',
        path: `${APP_PREFIX_PATH}/account-setting/profile`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/profile"), {
            fallback: '',
        }),
    }),
    isNotAdmin(APP_NAME !== "sportsxzone"?{
        key: 'contact-info',
        path: `${APP_PREFIX_PATH}/account-setting/contact`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/profile/Contact"), {
            fallback: '',
        }),
    }:{}),
    isSubAccount({
        key: 'body-ou-full-time',
        path: `${APP_PREFIX_PATH}/stock-management/full-time`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/FullTime"), {
            fallback: '',
        }),
    },true),
    isSubAccount({
        key: 'body-ou-half-time',
        path: `${APP_PREFIX_PATH}/stock-management/half-time`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/HalfTime"), {
            fallback: '',
        }),
    },true),
    isSubAccount({
        key: 'even-odd',
        path: `${APP_PREFIX_PATH}/stock-management/even-odd`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/EvenOdd"), {
            fallback: '',
        }),
    },true),
    // isSubAccount({
    //     key: 'one-x-two',
    //     path: `${APP_PREFIX_PATH}/stock-management/one-x-two`,
            // component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/OnexTwo"), {
            //     fallback: '',
            // }),
    // },true),
    // isSubAccount({
    //     key: 'correct-scores',
    //     path: `${APP_PREFIX_PATH}/stock-management/correct-scores`,
            // component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/CorrectScores"), {
            //     fallback: '',
            // }),
    // },true),
    isSubAccount({
        key: 'member-outstanding',
        path: `${APP_PREFIX_PATH}/stock-management/member-outstanding`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/MemberOustanding"), {
            fallback: '',
        }),
    },true),

    isSubAdmin({
        key: 'body-ou-full-time',
        path: `${APP_PREFIX_PATH}/stock-management/full-time`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/FullTime"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin({
        key: 'body-ou-half-time',
        path: `${APP_PREFIX_PATH}/stock-management/half-time`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/HalfTime"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin({
        key: 'even-odd',
        path: `${APP_PREFIX_PATH}/stock-management/even-odd`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/EvenOdd"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin({
        key: 'one-x-two',
        path: `${APP_PREFIX_PATH}/stock-management/one-x-two`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/OnexTwo"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin({
        key: 'correct-scores',
        path: `${APP_PREFIX_PATH}/stock-management/correct-scores`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/CorrectScores"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin({
        key: 'member-outstanding',
        path: `${APP_PREFIX_PATH}/stock-management/member-outstanding`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/MemberOustanding"), {
            fallback: '',
        }),
    },"access_reporting"),
    {
        key: 'stock-detail',
        path: `${APP_PREFIX_PATH}/stock-management/detail/:matchType/:oddsType/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/StockDetail"), {
            fallback: '',
        }),
    },
    {
        key: 'member-outstanding-detail',
        path: `${APP_PREFIX_PATH}/stock-management/member-outstanding/:usercode/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member-management/MemberOustanding"), {
            fallback: '',
        }),
    },
    isSubAccount({
        key: 'report-win-lose',
        path: `${APP_PREFIX_PATH}/report/win-lose-report/main`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseMain"), {
            fallback: '',
        }),
    },true),
    isSubAccount(APP_NAME !== "sportsxzone"?{
        key: 'report-win-lose',
        path: `${APP_PREFIX_PATH}/report/win-lose-report/bonus`,
        component: React.lazy(() => import('views/app-views/report/WinLoseBonus')),
    }:{},true),
    // isSubAccount(!isStartWithUsercode ? {
    //     key: 'report-win-lose-slot-v2',
    //     path: `${APP_PREFIX_PATH}/report/win-lose-report-slot/v2`,
    //     component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseSlotSummary"), {
    //         fallback: '',
    //     }),
    // }:{},true),
    isSubAccount({
        key: 'transaction-history',
        path: `${APP_PREFIX_PATH}/report/transaction-history`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/TransactionHistory"), {
            fallback: '',
        }),
    },true),
    isSubAdmin({
        key: 'report-win-lose',
        path: `${APP_PREFIX_PATH}/report/win-lose-report/main`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseMain"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin(APP_NAME !== "sportsxzone"?{
        key: 'report-win-lose',
        path: `${APP_PREFIX_PATH}/report/win-lose-report/bonus`,
        component: React.lazy(() => import('views/app-views/report/WinLoseBonus')),
    }:{},"access_reporting"),
    // isSubAdmin(!isStartWithUsercode ? {
    //     key: 'report-win-lose-slot-v2',
    //     path: `${APP_PREFIX_PATH}/report/win-lose-report-slot/v2`,
    //     component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseSlotSummary"), {
    //         fallback: '',
    //     }),
    // }:{},"access_reporting"),
    isSubAdmin({
        key: 'transaction-history',
        path: `${APP_PREFIX_PATH}/report/transaction-history`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/TransactionHistory"), {
            fallback: '',
        }),
    },"access_reporting"),
    // isSubAccount({
    //     key: 'report-win-lose',
    //     path: `${APP_PREFIX_PATH}/report/win-lose-report/:usercode/:id/:start_date/:end_date`,
        // component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLose"), {
        //     fallback: '',
        // }),
    // },true),
    // isSubAccount({
    //     key: 'report-win-lose-slot-v2',
    //     path: `${APP_PREFIX_PATH}/report/win-lose-report-slot/v2/:usercode/:id/:start_date/:end_date`,
        // component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseSlotSummary"), {
        //     fallback: '',
        // }),
    // },true),
    // isSubAdmin({
    //     key: 'report-win-lose',
    //     path: `${APP_PREFIX_PATH}/report/win-lose-report/:usercode/:id/:start_date/:end_date`,
        // component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLose"), {
        //     fallback: '',
        // }),
    // },"access_reporting"),
    // isSubAdmin({
    //     key: 'report-win-lose-slot-v2',
    //     path: `${APP_PREFIX_PATH}/report/win-lose-report-slot/v2/:usercode/:id/:start_date/:end_date`,
        // component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseSlotSummary"), {
        //     fallback: '',
        // }),
    // },"access_reporting"),

    {
        key: 'report-win-lose-slot',
        path: `${APP_PREFIX_PATH}/report/win-lose-report-slot/:usercode/:id/:start_date/:end_date`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseSlot"), {
            fallback: '',
        }),
    },
    {
        key: 'report-win-lose-slot',
        path: `${APP_PREFIX_PATH}/report/win-lose-report-slot`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseSlot"), {
            fallback: '',
        }),
    },
    isAdmin({
        key: 'create-odds',
        path: `${APP_PREFIX_PATH}/football/create-odds`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/football/CreateOdds"), {
            fallback: '',
        }),
    }),
    isAdmin({
        key: 'created-odds',
        path: `${APP_PREFIX_PATH}/football/created-odds`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/football/CreatedOdds"), {
            fallback: '',
        }),
    }),
    isAdmin({
        key: 'create-result',
        path: `${APP_PREFIX_PATH}/football/create-result`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/football/CreateResult"), {
            fallback: '',
        }),
    }),
    isAdmin({
        key: 'teams',
        path: `${APP_PREFIX_PATH}/football/teams`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/football/Teams"), {
            fallback: '',
        }),
    }),
    isAdmin({
        key: 'setting',
        path: `${APP_PREFIX_PATH}/football/setting`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/football/Settings"), {
            fallback: '',
        }),
    }),

    isSubAdmin({
        key: 'create-odds',
        path: `${APP_PREFIX_PATH}/football/create-odds`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/football/CreateOdds"), {
            fallback: '',
        }),
    },"manage_matches"),
    isSubAdmin({
        key: 'created-odds',
        path: `${APP_PREFIX_PATH}/football/created-odds`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/football/CreatedOdds"), {
            fallback: '',
        }),
    },"manage_matches"),
    isSubAdmin({
        key: 'create-result',
        path: `${APP_PREFIX_PATH}/football/create-result`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/football/CreateResult"), {
            fallback: '',
        }),
    },"confirm_scores"),
    isSubAccount({
        key: 'bet-list-single',
        path: `${APP_PREFIX_PATH}/bet-list/single`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListSingle"), {
            fallback: '',
        }),
    },true),
    isSubAccount({
        key: 'bet-list-parlay',
        path: `${APP_PREFIX_PATH}/bet-list/parlay`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListParlay"), {
            fallback: '',
        }),
    },true),
    isSubAccount({
        key: 'bet-list-all',
        path: `${APP_PREFIX_PATH}/bet-list/:typeName/:id/:unitType`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListAll"), {
            fallback: '',
        }),
    },true),
    isSubAccount({
        key: 'bet-list-all',
        path: `${APP_PREFIX_PATH}/bet-list/:typeName/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListAll"), {
            fallback: '',
        }),
    },true),
    isSubAccount({
        key: 'slot-bet-list-all',
        path: `${APP_PREFIX_PATH}/slot-bet-list/users/:id/`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/slot-betting/BetList"), {
            fallback: '',
        }),
    },true),
    isSubAccount({
        key: 'bet-list-parlay-detail',
        path: `${APP_PREFIX_PATH}/bet-list/detail/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListDetail"), {
            fallback: '',
        }),
    },true),
    isSubAdmin({
        key: 'bet-list-single',
        path: `${APP_PREFIX_PATH}/bet-list/single`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListSingle"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin({
        key: 'bet-list-parlay',
        path: `${APP_PREFIX_PATH}/bet-list/parlay`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListParlay"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin({
        key: 'bet-list-all',
        path: `${APP_PREFIX_PATH}/bet-list/:typeName/:id/:unitType`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListAll"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin({
        key: 'bet-list-all',
        path: `${APP_PREFIX_PATH}/bet-list/:typeName/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListAll"), {
            fallback: '',
        }),
    },"access_reporting"),
    isSubAdmin({
        key: 'slot-bet-list-all',
        path: `${APP_PREFIX_PATH}/slot-bet-list/users/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/slot-betting/BetList"), {
            fallback: '',
        }),
    },"access_reporting"),

    isSubAdmin({
        key: 'bet-list-parlay-detail',
        path: `${APP_PREFIX_PATH}/bet-list/detail/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/BetListDetail"), {
            fallback: '',
        }),
    },"access_reporting"),

    // 2D

    isSubAccount(APP_NAME !== "sportsxzone"?{
        key: 'report-win-lose-2d',
        path: `${APP_PREFIX_PATH}/report/win-lose-report-2d`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseTwod"), {
            fallback: '',
        }),
    }:{},true),
    
    isSubAdmin(APP_NAME !== "sportsxzone"? {
        key: 'report-win-lose-2d',
        path: `${APP_PREFIX_PATH}/report/win-lose-report-2d`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseTwod"), {
            fallback: '',
        }),
    }:{},"access_reporting"),

    isSubAdmin(APP_NAME !== "sportsxzone"?{
        key: '2D-bet-list-detail',
        path: `${APP_PREFIX_PATH}/2d-bet-list/detail/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/Twod/BetListDetail"), {
            fallback: '',
        }),
    }:{},"access_reporting"),

    isSubAccount(APP_NAME !== "sportsxzone"? {
        key: '2D-bet-list-detail',
        path: `${APP_PREFIX_PATH}/2d-bet-list/detail/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/Twod/BetListDetail"), {
            fallback: '',
        }),
    }:{},true),

    isSubAccount(APP_NAME !== "sportsxzone"?{
        key: '2d-bet-list-all',
        path: `${APP_PREFIX_PATH}/2d-bet-list/user/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/Twod/BetList"), {
            fallback: '',
        }),
    }:{},true),

    isSubAdmin(APP_NAME !== "sportsxzone"?{
        key: '2d-bet-list-all',
        path: `${APP_PREFIX_PATH}/2d-bet-list/user/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/Twod/BetList"), {
            fallback: '',
        }),
    }:{},"access_reporting"),

    isAdmin(APP_NAME !== "sportsxzone"?{
        key: '2dsetting',
        path: `${APP_PREFIX_PATH}/2d/setting`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/twod/Setting"), {
            fallback: '',
        }),
    }:{}),
    isAdmin(APP_NAME !== "sportsxzone"?{
        key: '2dresult',
        path: `${APP_PREFIX_PATH}/2d/result`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/twod/Result"), {
            fallback: '',
        }),
    }:{}),
    APP_NAME !== "sportsxzone"?
    {
        key: '2dhistory',
        path: `${APP_PREFIX_PATH}/2d/bet-lists`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/twod/BetHistory"), {
            fallback: '',
        }),
    }:{},
    APP_NAME !== "sportsxzone"?{
        key: '2dwinners',
        path: `${APP_PREFIX_PATH}/2d/winners`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/twod/Winner"), {
            fallback: '',
        }),
    }:{},
    APP_NAME !== "sportsxzone"?{
        key: '2dstock',
        path: `${APP_PREFIX_PATH}/stock-management/2d-stock`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/twod/Stock"), {
            fallback: '',
        }),
    }:{},
    {
        key: '2dstock-detail',
        path: `${APP_PREFIX_PATH}/stock-management/2d-stock/:digit`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/twod/StockDetail"), {
            fallback: '',
        }),
    },
    APP_NAME !== "sportsxzone"?{
        key: '2doutstanding',
        path: `${APP_PREFIX_PATH}/stock-management/2d-outstanding`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/twod/Outstanding"), {
            fallback: '',
        }),
    }:{},
    // 3D
    isSubAccount(!isStartWithUsercode ? {
        key: 'report-win-lose-3d',
        path: `${APP_PREFIX_PATH}/report/win-lose-report-3d`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseThreed"), {
            fallback: '',
        }),
    }:{},true),

    isSubAdmin(!isStartWithUsercode ? {
        key: 'report-win-lose-3d',
        path: `${APP_PREFIX_PATH}/report/win-lose-report-3d`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/report/WinLoseThreed"), {
            fallback: '',
        }),
    }:{},"access_reporting"),

    isSubAdmin(!isStartWithUsercode ? {
        key: '3D-bet-list-detail',
        path: `${APP_PREFIX_PATH}/3d-bet-list/detail/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/Threed/BetListDetail"), {
            fallback: '',
        }),
    }:{},"access_reporting"),
    
    isSubAccount(!isStartWithUsercode ? {
        key: '3D-bet-list-detail',
        path: `${APP_PREFIX_PATH}/3d-bet-list/detail/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/Threed/BetListDetail"), {
            fallback: '',
        }),
    }:{},true),

    isSubAccount(!isStartWithUsercode ? {
        key: '3d-bet-list-all',
        path: `${APP_PREFIX_PATH}/3d-bet-list/user/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/Threed/BetList"), {
            fallback: '',
        }),
    }:{},true),
    isSubAdmin({
        key: '3d-bet-list-all',
        path: `${APP_PREFIX_PATH}/3d-bet-list/user/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/bet-list/Threed/BetList"), {
            fallback: '',
        }),
    },"access_reporting"),

    isAdmin(!isStartWithUsercode ? {
        key: '3dsetting',
        path: `${APP_PREFIX_PATH}/3d/setting`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/threed/Setting"), {
            fallback: '',
        }),
    }:{}),
    isAdmin({
        key: '3dresult',
        path: `${APP_PREFIX_PATH}/3d/result`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/threed/Result"), {
            fallback: '',
        }),
    }),
    {
        key: '3dhistory',
        path: `${APP_PREFIX_PATH}/3d/bet-lists`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/threed/BetHistory"), {
            fallback: '',
        }),
    },
    {
        key: '3dwinners',
        path: `${APP_PREFIX_PATH}/3d/winners`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/threed/Winner"), {
            fallback: '',
        }),
    },
    {
        key: '3dstock',
        path: `${APP_PREFIX_PATH}/stock-management/3d-stock`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/threed/Stock"), {
            fallback: '',
        }),
    },
    {
        key: '3dstock-detail',
        path: `${APP_PREFIX_PATH}/stock-management/3d-stock/:digit/:time`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/threed/StockDetail"), {
            fallback: '',
        }),
    },
    {
        key: '3doutstanding',
        path: `${APP_PREFIX_PATH}/stock-management/3d-outstanding`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/threed/Outstanding"), {
            fallback: '',
        }),
    },

    isAdmin(APP_NAME !== "sportsxzone"?{
        key: 'pays',
        path: `${APP_PREFIX_PATH}/pays`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/payment/Pays"), {
            fallback: '',
        }),
    }:{}),
    isAgent(APP_NAME !== "sportsxzone"?{
        key: 'pay-accounts',
        path: `${APP_PREFIX_PATH}/pay-accounts`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/payment/PayAccounts"), {
            fallback: '',
        }),
    }:{}),
    APP_NAME !== "sportsxzone"?{
        key: 'deposit',
        path: `${APP_PREFIX_PATH}/deposit`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/payment/Deposit"), {
            fallback: '',
        }),
    }:{},
    isAdmin(APP_NAME === "1xmix"?{
        key: 'withdraw',
        path: `${APP_PREFIX_PATH}/withdraw`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/payment/Withdraw"), {
            fallback: '',
        }),
    }:{}),



    ...usersRoute,
    isSubAccount(!isStartWithUsercode ? {
        key: 'member-sub-account',
        path: `${APP_PREFIX_PATH}/member/sub-account`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/SubAccount"), {
            fallback: '',
        }),
    }:{},false),
    isAdmin(APP_NAME === "1xmix"?{
        key: 'apply-agent',
        path: `${APP_PREFIX_PATH}/member/apply-agent`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/ApplyAgent"), {
            fallback: '',
        }),
    }:{}),
    isSubAccount(!isStartWithUsercode ? {
        key: 'create-sub-account',
        path: `${APP_PREFIX_PATH}/member/create-sub-account`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/CreateSubAccount"), {
            fallback: '',
        }),
    }:{},false),
    isSubAccount({
        key: 'create-user',
        path: `${APP_PREFIX_PATH}/member/:role/create`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/CreateUser"), {
            fallback: '',
        }),
    },false),
    isSubAccount({
        key: 'edit-user',
        path: `${APP_PREFIX_PATH}/member/:role/edit/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/EditUser"), {
            fallback: '',
        }),
    },false),
    isSubAccount({
        key: 'deposit-withdrawl',
        path: `${APP_PREFIX_PATH}/payment/deposit-withdrawl`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/payment/DepositWithdrawl"), {
            fallback: '',
        }),
    },false),
    {
        key: 'payment-transactions',
        path: `${APP_PREFIX_PATH}/payment/transactions`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/payment/Downline"), {
            fallback: '',
        }),
    },
    isAdmin({
        key: 'payment-reports',
        path: `${APP_PREFIX_PATH}/payment/report`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/payment/PaymentReport"), {
            fallback: '',
        }),
    }),
    {
        key: 'old-create-user',
        path: `${APP_PREFIX_PATH}/member/old-version/:role/create`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/old-version/CreateUser"), {
            fallback: '',
        }),
    },
    {
        key: 'old-edit-user',
        path: `${APP_PREFIX_PATH}/member/old-version/:role/edit/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/member/old-version/EditUser"), {
            fallback: '',
        }),
    },
    {
        key: 'wallet-transaction',
        path: `${APP_PREFIX_PATH}/transactions`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/transaction/Transaction"), {
            fallback: '',
        }),
    },
    isAdmin(
    {
        key: 'wallet-transaction-detail',
        path: `${APP_PREFIX_PATH}/transaction`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/transaction/TransactionDetail"), {
            fallback: '',
        }),
    }),

    isAdmin(
        {
            key: 'user-transaction',
            path: `${APP_PREFIX_PATH}/payment/transaction`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/transaction/CheckUserTransaction"), {
                fallback: '',
            }),
        }
    ),
    isAgent(
        !isStartWithUsercode ? {
            key: 'wallet-transaction',
            path: `${APP_PREFIX_PATH}/user-transactions/wallet`,
            component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/transaction/Wallet"), {
                fallback: '',
            }),
        }
    :{}),
    {
        key: 'check-slip-id',
        path: `${APP_PREFIX_PATH}/user-transactions/betting`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/transaction/Betting"), {
            fallback: '',
        }),
    },
    
    isAdmin({
        key: 'app-setting',
        path: `${APP_PREFIX_PATH}/app-setting`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/setting/AppSetting"), {
            fallback: '',
        }),
    }),
    isAdmin({
        key: 'notification',
        path: `${APP_PREFIX_PATH}/notification`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/setting/Notification"), {
            fallback: '',
        }),
    }),
    isAdmin({
        key: 'tips',
        path: `${APP_PREFIX_PATH}/tips`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/community/Tips"), {
            fallback: '',
        }),
    }),
    isAdmin({
        key: 'create-tips',
        path: `${APP_PREFIX_PATH}/tips/create`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/community/CreateTips"), {
            fallback: '',
        }),
    }),
    isAdmin({
        key: 'edit-tips',
        path: `${APP_PREFIX_PATH}/tips/edit/:id`,
        component: loadable(() => import(/* webpackPrefetch: true */"views/app-views/community/EditTips"), {
            fallback: '',
        }),
    }),
];
